import { ScheduledCommunicationTypesQueries } from '@/graphql/queries/scheduledCommunicationTypes.queries'
import { ScheduledCommunicationTypeList } from '@/types/ScheduledCommunicationType'

import { useGraphql } from '../useGraphql'

const useScheduledCommunicationTypes = () => {
  return useGraphql<{ scheduledCommunicationTypes: ScheduledCommunicationTypeList[] }>(
    ScheduledCommunicationTypesQueries.QUERY_KEYS.getScheduledCommunicationTypes,
    ScheduledCommunicationTypesQueries.getScheduledCommunicationTypes(),
    {},
  )
}

export default useScheduledCommunicationTypes
